import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import BrandLeadsEntryPoint from "../../pages/Leads/BrandLeadsEntryPoint";
import { LeadsContainerProps } from "../../interfaces/containers";
import { getBrandLeads } from "../../actions/leads";
import { getPublicationBrand } from "../../actions/publication";

function mapStateToProps(state: LeadsContainerProps) {
    return{ 
        fetchingLeads: state.leads.fetching,
        leads: state.leads.leads
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getBrandLeads,
        getPublicationBrand
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandLeadsEntryPoint);
